/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Tool_Discount_CopiedInputs */

const en_directory_tool_discount_copied = /** @type {(inputs: Directory_Tool_Discount_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copied`)
};

const zh_directory_tool_discount_copied = /** @type {(inputs: Directory_Tool_Discount_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已复制`)
};

/**
* | output |
* | --- |
* | "Copied" |
*
* @param {Directory_Tool_Discount_CopiedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_tool_discount_copied = /** @type {((inputs?: Directory_Tool_Discount_CopiedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Tool_Discount_CopiedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_tool_discount_copied(inputs)
	return zh_directory_tool_discount_copied(inputs)
});
export { directory_tool_discount_copied as "directory.tool.discount_copied" }